module.exports = __webpack_public_path__ + "img/Cerrar_B.4d0289c0.svg";